<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex'
import { createWidgetMixin } from 'vue-instantsearch'
import { connectCurrentRefinements } from 'instantsearch.js/es/connectors/'
import { generalHelpers } from '@/_helpers'

export default {
  name: 'AlgoliaSelectedFiltersWatcher',
  components: {},
  mixins: [
    createWidgetMixin({ connector: connectCurrentRefinements })
  ],
  props: {},
  data () {
    return {}
  },
  computed: {
    algoliaSelectedFilters () {
      let results = []

      if (this.state !== null) {
        results = this.state.items
      }

      return results
    }
  },
  watch: {
    algoliaSelectedFilters (filters, oldFilters) {
      if (!generalHelpers.isEqual(filters, oldFilters)) {
        let filtersArr = []
        filters.forEach(filter => {
          let filterStr = ''
          let filterObj = {
            attribute: filter.attribute,
            type: '',
            values: []
          }
          filter.refinements.forEach((refinement, index) => {
            if (index === 0) {
              filterObj.type = refinement.type
            }
            if (refinement.type !== 'numeric') {
              filterStr = filterStr + filter.attribute + ':' + '\'' + refinement.value + '\''
              if (index !== filter.refinements.length - 1) {
                filterStr += ' OR '
              }
            } else {
              if (filter.refinements.length === 1) {
                filterStr = filter.attribute + ' ' + refinement.operator + ' ' + refinement.value
              } else {
                if (index === 0) {
                  filterStr = filter.attribute + ':' + refinement.value + ' TO '
                } else {
                  filterStr += refinement.value
                }
              }
            }
            if (refinement.type === 'numeric') {
              filterObj.values.push({ value: refinement.value, operator: refinement.operator })
            } else {
              filterObj.values.push(refinement.value)
            }
          })
          filtersArr.push({ filter: filterStr, filterObj: filterObj })
        })
        this.setAllSelectedFilters(filtersArr)
      }
    }
  },
  methods: {
    ...mapActions({
      setAllSelectedFilters: 'setAllSelectedFilters'
    })
  },
  created () {}
}
</script>

<style lang="scss" scoped>

</style>
